import React from 'react';
import Form from 'react-bootstrap/Form';



function MissingEmailForm (props) {
    return (
        <Form.Group id = "createEmailGroup"  className= "relative">
                <Form.Label className = {`${props.floatEmail === true ? "absolute floating-label" : "absolute inline-label" }
                                        ${props.emailFocus === true ? "label-black__TO" : "" }
                                        ${props.isEmailValid === false && props.emailFocus === false ? "label-red__TO" : ""}
                `} 
                style={props.emailFocus === true ? {'top': '-9px'} : {}}>
                    Email<span id="redStar">*</span></Form.Label>
                <Form.Control
                required
                id = "createEmail__TO"
                data-testid = "createEmail"
                aria-label = "Email"
                as = "input"
                type = "text"
                name = "email"
                value = {props.mail}
                onChange = {props.handleEmailChange}
                onFocus = {props.setFocusEmail}
                onBlur = {props.onBlurEmail}
                bsPrefix = {`${(props.isEmailValid === false || props.isEmailAvailable === false) && props.emailFocus === false ? "highlight-error__TO form-control" : ""}`}

            />
            <div
                id = "createEmailAlert" 
                data-testid = "createEmailError" 
                className = {`logon-item-error__TO ${props.isEmailValid === false && props.emailFocus == false ? "block" : "none"}`}
                role = "alert" 
                aria-hidden = {`${props.isEmailValid === false && props.emailFocus === false ? "false" : "true"}`}
            >
                Please enter a valid email address.
            </div>
            {/* // TODO: VISIT THE ISSUE OF REGISTERING USERS WITH EXISTING ACCOUNTS */}
            <div 
                id = "createEmailError" 
                data-testid = "createEmailError" 
                className = {`logon-item-error__TO ${props.isEmailAvailable === false && props.emailFocus === false? "block" : "none"}`}
                role = "alert"
                aria-hidden = {`${props.isEmailAvailable === false && props.emailFocus === false ? "false" : "true"}`}
            >
                This email is already in use. Do you want to <a href="/">sign in</a>? If you want to link your accounts please make sure your email address is registed with Facebook, verified, and shared with this application.
            </div>
        </Form.Group>
    )
}

export default MissingEmailForm;